import { format, unwrapFunctionStore } from 'svelte-i18n';

import { campaignsSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const cloneViaEditView = {
  element: '#campaigns > tbody > tr:nth-child(1)',
  popover: {
    title: 'Cloning via Campaign Editor',
    description:
      'Navigate to the Campaign Editor page by clicking the <strong>&quot;Edit&quot;</strong> button in the actions menu or by clicking the campaign creative.',
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const actionsBtn = document.querySelector(
        '#campaigns > tbody > tr:nth-child(1) > td:nth-child(5) > div > span > i'
      );

      if (actionsBtn) {
        actionsBtn.click();

        GLOBAL_DRIVER_OBJECT.movePrevious();
      }
    },
    onNextClick: () => {
      const campaignCreative = document.querySelector('#campaigns > tbody > tr:nth-child(1) > td:nth-child(1) > div');

      if (campaignCreative) {
        campaignCreative.click();

        GLOBAL_DRIVER_OBJECT.moveNext();
      }
    }
  }
};

export const cloneEditViewOptions = {
  element: 'div.col-4.col-sm-6.col-md-6.text-right > span > div > button',
  popover: {
    onPopoverRender: () => {
      const actionsBtn = document.querySelector('div.col-4.col-sm-6.col-md-6.text-right > span > div > button');

      if (actionsBtn) {
        actionsBtn.click();

        GLOBAL_DRIVER_OBJECT.highlight({
          element:
            '#campaign-editor > div.page-header > div > div.flex-align--center.row > div.col-4.col-sm-6.col-md-6.text-right > span > div > ul',
          popover: {
            title: 'Cloning via Campaign Editor',
            description:
              'To clone a campaign from the <strong>Campaign Editor</strong>, click the <strong>&quot;Actions&quot;</strong> menu and choose <strong>&quot;Clone&quot;</strong> from the dropdown options.',
            side: 'left',
            align: 'start',
            showButtons: ['next'],
            nextBtnText: 'Done',
            onNextClick: () => {
              const closeBtn = document.querySelector(
                '#campaign-editor > div.page-header > div > div.flex-align--center.row > div.col-4.col-sm-6.col-md-6.text-right > button.hide--mobile.me-2.btn.btn-secondary'
              );

              campaignsSettingsStore.subscribe((campaigns) => {
                campaigns.tours.cloneHasToured = true;
              })();

              if (closeBtn) {
                closeBtn.click();

                GLOBAL_DRIVER_OBJECT.destroy();
              }
            }
          }
        });
      }
    }
  }
};
